import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DurationPickerModule } from 'ngx-duration-picker';
import { EntityGroupSubsetComponent } from '../../components/views/entity-group/entity-group-details/entity-group-subset/entity-group-subset.component';
import { ActionService } from '../../components/action/action.service';
import { ActionModalComponent } from '../../components/action/action-modal/action-modal.component';
import { ActionComponent } from '../../components/action/action.component';
import { FormFieldComponent } from '../../components/data-type-widgets/form-field/form-field.component';
import { MaintainFiltersComponent } from '../../components/views/maintain/maintain-table/maintain-filters/maintain-filters.component';
import { TableCellAnchorDirective } from '../../components/data-type-widgets/table-cell/table-cell-anchor.directive';
import { FormFieldAnchorDirective } from '../../components/data-type-widgets/form-field/form-field-anchor.directive';
import { MaintainTableRowActionsComponent } from '../../components/views/maintain/maintain-table/maintain-table-row-actions/maintain-table-row-actions.component';
import { TableCellComponent } from '../../components/data-type-widgets/table-cell/table-cell.component';
import { AppWalletManualAdjustmentComponent } from '../../components/views/entity-group/entity-group-details/entity-group-actions/app-wallet-manual-adjustment/app-wallet-manual-adjustment.component';
import { EntityGroupTabsComponent } from '../../components/views/entity-group/entity-group-details/entity-group-tabs/entity-group-tabs.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { StopwatchComponent } from '../../components/stopwatch/stopwatch.component';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { WageringProfileOverallComponent } from '../../feature/manage/offers/wagering-profiles/wagering-profile-overall/wagering-profile-overall.component';
import { WageringProfileGameListComponent } from '../../feature/manage/offers/wagering-profiles/wagering-profile-overall/wagering-profile-game-list.component';

export const declareExportComponents = [
  TableCellComponent,
  MaintainTableRowActionsComponent,
  TableCellAnchorDirective,
  FormFieldAnchorDirective,
  MaintainFiltersComponent,
  FormFieldComponent,
  ActionComponent,
  ActionModalComponent,
  EntityGroupSubsetComponent,
  AppWalletManualAdjustmentComponent,
  EntityGroupTabsComponent,
  StopwatchComponent,
  WageringProfileOverallComponent,
  WageringProfileGameListComponent,
];

export const declareExportModules = [
  CommonModule,
  MatTableModule,
  MatIconModule,
  MatToolbarModule,
  MatSidenavModule,
  MatListModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatMenuModule,
  MatCardModule,
  MatSnackBarModule,
  MatSortModule,
  MatTooltipModule,
  MatTabsModule,
  DragDropModule,
  MatFormFieldModule,
  MatPaginatorModule,
  MatGridListModule,
  MatInputModule,
  MatDialogModule,
  MatCheckboxModule,
  MatSelectModule,
  MatStepperModule,
  ReactiveFormsModule,
  FormsModule,
  MatSlideToggleModule,
  FormsModule,
  ReactiveFormsModule,
  ColorPickerModule,
  RouterModule,
  CodemirrorModule,
  MatTreeModule,
  MatChipsModule,
  MatDividerModule,
  MatDatepickerModule,
  MatMomentDateModule,
  NgxMaterialTimepickerModule.setOpts('en-GB'),
  ScrollingModule,
  DurationPickerModule,
  OverlayModule,
];

@NgModule({
  imports: [declareExportModules],
  exports: [declareExportComponents, declareExportModules],
  declarations: [declareExportComponents],
  providers: [ActionService, { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],
})
export class AdminBaseModule {}
